export const USER_CACHE_IDENTIFIER = "budd-user";
export const USERID_COOKIE_IDENTIFIER = "user_id"; // used in GTM for User identification
